<script>
	import { gsap } from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'
	import { onMount } from 'svelte'

	export let nav = []

	let y, serviceNavWrap, serviceNavWrapTop, navItems
	let navParent = document.getElementById('pageNav')

	// $: console.log('y:', y)

	$: if (y >= serviceNavWrapTop) {
		navParent.classList.add('sticky-service-nav')
	}

	$: if (y <= serviceNavWrapTop) {
		navParent.classList.remove('sticky-service-nav')
	}

	onMount(() => {
		serviceNavWrapTop = serviceNavWrap.getBoundingClientRect().top

		gsap.registerPlugin(ScrollTrigger)
		let navItems = document.querySelectorAll('.service-nav-item')
		if (navItems) {
			let nav_tl = gsap.timeline({
				scrollTrigger: {
					trigger: '#pageNav',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})
			navItems.forEach((navItem, i) => {
				nav_tl.fromTo(
					navItem,
					{ opacity: 0, y: 20 },
					{
						delay: i * 0.002,
						duration: 0.25,
						opacity: 1,
						y: 0,
						stagger: 0.2,
						ease: 'power1.out',
					}
				)
			})
		}
	})
</script>

<svelte:window bind:scrollY={y} />

<div bind:this={serviceNavWrap}>
	{#each nav as item}
		<a href={item.link} class="service-nav-item">
			{@html item.name}
		</a>
	{/each}
</div>
